(function () {
  function initAceiiKeyMoments(root) {
    if (!root || root.dataset.initialized === 'true') return;

    var dataNode = root.querySelector('[data-key-moments-json]');
    if (!dataNode) return;

    var moments;

    try {
      moments = JSON.parse(dataNode.textContent || '[]');
    } catch (error) {
      return;
    }

    if (!moments.length) return;

    root.dataset.initialized = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.akm-tab'));
    var imageCard = root.querySelector('.akm-image-card');
    var image = root.querySelector('.akm-image');
    var title = root.querySelector('.akm-title');
    var text = root.querySelector('.akm-text');
    var imageCache = {};
    var activeRequest = 0;

    function preloadMomentImage(item) {
      if (!item || !item.image) return null;
      if (imageCache[item.image]) return imageCache[item.image];

      var preloadImage = new Image();
      preloadImage.decoding = 'async';
      preloadImage.src = item.image;
      imageCache[item.image] = preloadImage;

      return preloadImage;
    }

    function preloadImages() {
      moments.forEach(preloadMomentImage);
    }

    function schedulePreload() {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            preloadImages();
            observer.disconnect();
          });
        }, {
          rootMargin: '600px 0px'
        });

        observer.observe(root);
        return;
      }

      window.setTimeout(preloadImages, 0);
    }

    function finishImageChange(requestId) {
      if (requestId !== activeRequest) return;
      if (imageCard) imageCard.classList.remove('is-changing');
    }

    function swapImage(item) {
      if (!image || !item.image) {
        if (imageCard) imageCard.classList.remove('is-changing');
        return;
      }

      activeRequest += 1;

      var requestId = activeRequest;
      var preloadedImage = preloadMomentImage(item);

      if (imageCard) imageCard.classList.add('is-changing');

      image.onload = function () {
        finishImageChange(requestId);
      };
      image.onerror = function () {
        finishImageChange(requestId);
      };
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.alt = item.alt || item.title || '';
      image.src = item.image;

      if (preloadedImage && preloadedImage.complete && image.complete) {
        window.requestAnimationFrame(function () {
          finishImageChange(requestId);
        });
      }
    }

    function setActive(index) {
      var item = moments[index];
      if (!item) return;

      tabs.forEach(function (tab) {
        tab.classList.toggle('is-active', tab.getAttribute('data-index') === String(index));
      });

      swapImage(item);

      if (title) title.textContent = item.title || '';
      if (text) text.textContent = item.text || '';
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActive(parseInt(tab.getAttribute('data-index'), 10));
      });
    });

    schedulePreload();
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-about-key-moments]');

    Array.prototype.forEach.call(sections, initAceiiKeyMoments);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
